import { APOLLO_OPTIONS } from 'apollo-angular';
import { HttpLink } from 'apollo-angular/http';
import { inject, NgModule } from '@angular/core';
import { ApolloClientOptions, ApolloLink, InMemoryCache, concat } from '@apollo/client/core';
import { environment } from 'src/environments/environment';
import { setContext } from '@apollo/client/link/context';
import { AuthTokenService } from './services/auth-token.service';
import { provideApollo } from 'apollo-angular';

export function createApollo(httpLink: HttpLink, authTokenService: AuthTokenService): ApolloClientOptions<any> {
  const authenticityTokenRequestHandler = setContext(async (operation, prevContext) => {
    const authTokens = await authTokenService.getAuthTokens()

    const headers: Record<string, any> = {
      "X-CSRF-Token": authTokens.authenticityToken
    }

    const frontendApiBasicAuth = authTokens.frontendApiBasicAuth
    if (frontendApiBasicAuth) {
      headers["Authorization"] = "Basic " + frontendApiBasicAuth
    }

    return { headers }
  })

  const uri = environment.legacyAppUrl + '/graphql_frontend';
  const sourceLink = httpLink.create({ uri, withCredentials: true })

  return {
    link: concat(authenticityTokenRequestHandler, sourceLink),
    defaultOptions: {
      watchQuery: {
        fetchPolicy: 'no-cache',
        errorPolicy: 'none'
      },
      query: {
        fetchPolicy: 'no-cache',
        errorPolicy: 'none'
      },
      mutate: {
        fetchPolicy: 'no-cache',
        errorPolicy: 'none'
      }
    },
    cache: new InMemoryCache(),
  };
}

@NgModule({
  providers: [
    provideApollo(() => {
      const httpLink = inject(HttpLink);
      const authTokenService = inject(AuthTokenService);
      return createApollo(httpLink, authTokenService);
    }),
  ],
})
export class GraphQLModule {}
